<div
  class="border-primary-500 rounded-2xl border-l-8 bg-neutral-50 p-5 shadow-lg"
  [ngClass]="selected() ? 'border-primary-500' : 'border-neutral-300'"
>
  <div class="flex items-center justify-between">
    <div class="flex w-10/12 flex-col gap-2">
      <div class="flex">
        <span class="w-3/12 text-neutral-300">ПІБ Лікаря</span>
        <span class="w-8/12">{{ eleksVisitData().doctorName }}</span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-neutral-300">Адреса</span>
        <span class="w-8/12">
          {{ eleksVisitData()?.location }}
        </span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-neutral-300">Дата та час візиту</span>
        <span class="w-8/12">
          {{ formatDate(eleksVisitData().startDate, true) }}
          - {{ eleksVisitData().endDate | date: "HH:mm" }}
        </span>
      </div>
    </div>

    <div class="flex w-2/12 items-center justify-end">
      @if (!selected()) {
        <button
          class="btn btn-primary text-sm"
          (click)="selectEleksVisit(true)"
        >
          Обрати
        </button>
      } @else {
        <button
          class="bg-primary-500 flex items-center justify-center rounded-full p-2 text-neutral-50"
          (click)="selectEleksVisit(false)"
        >
          <mat-icon>done</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
